import React from "react";
import { useSelector } from "react-redux";
import loaderGif from "../../assets/gif/loader.gif"; 

const loader = {
 position : 'fixed',
    width : '100%',
    height : '100%',
    background: 'rgb(0 0 0 / 70%)',
    zIndex : 111111,

}
const loadergif = {
  position : 'absolute',
  top : '50%',
  left : '50%',
  transform: 'translate(-50%, -50%)', 
  width:'400px'
}

 const Loader = () => {
  const isLoading = useSelector((state) => state.loading.isLoading);

  return (
    (isLoading ? 
      <div style={loader}>
        <img src={loaderGif} alt="Loading..." style={loadergif} />
      </div> : null
    )
  );
};
 export default Loader;

